import { Link } from 'react-router-dom';
import LegalLayout from './LegalLayout';
import { OPERATOR } from './meta';

export default function Operator() {
  return (
    <LegalLayout title="運営者情報" enacted={OPERATOR.effectiveDate}>
      <h2>運営者</h2>
      <dl className="legal__dl">
        <dt>サービス名</dt>
        <dd>{OPERATOR.serviceName}</dd>
        <dt>運営者</dt>
        <dd>{OPERATOR.operatorName}</dd>
        {OPERATOR.tradeName && (
          <>
            <dt>屋号</dt>
            <dd>{OPERATOR.tradeName}</dd>
          </>
        )}
        <dt>お問い合わせ</dt>
        <dd>
          <Link to={OPERATOR.contactPath}>{OPERATOR.contactLabel}</Link>
        </dd>
        <dt>データの保管場所</dt>
        <dd>{OPERATOR.region}</dd>
      </dl>

      <h2>関連文書</h2>
      <p>本サービスのご利用にあたっては、あわせて次の各文書をご確認ください。</p>
      <ul>
        <li>利用規約</li>
        <li>プライバシーポリシー</li>
        <li>コミュニティガイドライン</li>
        <li>権利侵害の申告（送信防止措置の申出）</li>
        <li>クレジット・使用素材</li>
      </ul>

      <p className="legal__meta">制定日: {OPERATOR.effectiveDate}</p>
    </LegalLayout>
  );
}
